import { useState } from "react";

import { Stack, Typography } from "@mui/material";

import AttendanceIndicator from "@app/analytics/components/AttendanceIndicator";
import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";

import CarouselNotificationBanner from "../components/CarouselNotificationBanner";

const MEETING_TIPS = [
  {
    heading: "Not seeing a recent meeting?",
    body: (
      <Typography
        variant="detailReg"
        sx={{
          color: "white",
        }}
      >
        Reports are typically available within 30 minutes after a meeting ends,
        but can take up to an hour for meetings exceeding 2 hours.
      </Typography>
    ),
  },
  {
    heading: "Conference room detection",
    body: (
      <Typography
        variant="detailReg"
        sx={{
          display: "inline-flex",
          color: "white",
        }}
      >
        <span>
          When a conference room is detected during a meeting, your attendance
          defaults to&nbsp;
          <AttendanceIndicator inline type="conferenceRoom" />
          &nbsp;(conference room).
        </span>
      </Typography>
    ),
  },
  {
    heading: "Customize which meetings Read joins",
    body: (
      <Typography
        variant="detailReg"
        sx={{
          color: "white",
        }}
      >
        Manually toggle Read on or off for any meeting in&nbsp;
        <Link
          sx={{ textDecoration: "underline", color: "shades.secondary.300" }}
          to={ROUTES.CALENDAR}
        >
          your Calendar
        </Link>
        , or adjust your&nbsp;
        <Link
          sx={{ textDecoration: "underline", color: "shades.secondary.300" }}
          to={ROUTES.USER_SETTINGS_ASSISTANT}
        >
          join preferences
        </Link>
        &nbsp;in settings
      </Typography>
    ),
  },
];

const MeetingTipsBanner = () => {
  const [activeTipIndex, setActiveTipIndex] = useState(0);
  const currentStep = MEETING_TIPS[activeTipIndex];

  return (
    <CarouselNotificationBanner
      steps={MEETING_TIPS.length}
      activeStepIndex={activeTipIndex}
      setActiveStepIndex={setActiveTipIndex}
      localStorageName="meetingReportTipsBannerDismissed"
    >
      <Stack>
        <Typography
          variant="bodyPrimaryMed"
          sx={{
            color: "white",
          }}
        >
          {currentStep.heading}
        </Typography>

        {currentStep.body}
      </Stack>
    </CarouselNotificationBanner>
  );
};

export default MeetingTipsBanner;
